/**
 * Script Name: Mobile Menu Toggle Script
 * Version: 1.1
 * Description: Handles mobile menu toggling functionality in the header.
 * Author: Wubbe
 * Date: December 14, 2023
 */

/* Mobile Menu toggle */
// Look for .hamburger
var hamburger = document.querySelector(".hamburger");
var header = document.querySelector(".header");
var body = document.querySelector("body");
var links = document.querySelectorAll(".header__nav a[href]");
var cta = document.querySelectorAll("a.header__cta[href]");

// Function to handle hamburger click
function handleHamburgerClick() {
  hamburger.classList.toggle("is-active");
  header.classList.toggle("is-active");
  body.classList.toggle("overlay-active");
  // Additional logic to open/close menu can be added here
}

// Function to handle links click
function handleLinksClick() {
  if (hamburger.classList.contains("is-active")) {
    hamburger.classList.remove("is-active");
    header.classList.remove("is-active");
    body.classList.remove("overlay-active");
  }
}

// On click event listeners
hamburger.addEventListener("click", handleHamburgerClick);
links.forEach(function(link) {
    link.addEventListener("click", handleLinksClick);
});
cta.forEach(function(link) {
    link.addEventListener("click", handleLinksClick);
});